<template>
    <div class="widget widget-wallet-balance h-100">
        <div class="widget-heading d-block">
            <div class="wallet-balance">
                <div class="d-flex flex-column text-start">
                    <p class="mb-0">Recebidos</p>
                    <p class="text-muted text-small mb-0" style="align-self: flex-start;">este mês</p>
                </div>
                <div v-if="loadingSaldo" class="skeleton-saldo-value">
                    <div class="skeleton-line skeleton-line-value"></div>
                </div>
                <h5 v-else>{{ financeiroStore.getSaldoTotalFormatado }}</h5>
            </div>
        </div>
        <div class="widget-amount">
            <div class="w-a-info funds-received me-3">
                <span
                    >Disponível
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-up text-success float-end"
                    >
                        <polyline points="18 15 12 9 6 15"></polyline>
                    </svg>
                </span>
                <div v-if="loadingSaldo" class="skeleton-saldo-amount">
                    <div class="skeleton-line skeleton-line-amount"></div>
                </div>
                <p v-else>{{ financeiroStore.getSaldoDisponivelFormatado }}</p>
            </div>
            <div class="w-a-info funds-spent">
                <span
                    >Pendente
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-up text-warning float-end"
                    >
                        <polyline points="18 15 12 9 6 15"></polyline>
                    </svg>
                </span>
                <div v-if="loadingSaldo" class="skeleton-saldo-amount">
                    <div class="skeleton-line skeleton-line-amount"></div>
                </div>
                <p v-else>{{ financeiroStore.getSaldoPendenteFormatado }}</p>
            </div>
        </div>
        <div class="widget-content">
            <div class="invoice-list">
                <div class="inv-action">
                    <a href="/financeiro?tab=extrato" class="btn view-details btn-outline-secondary">Ver detalhes</a>
                    <a href="/financeiro?tab=saques&solicitar=1" class="btn pay-now btn-outline-success">Solicitar saque</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import "../../assets/sass/widgets/widgets.scss";
import { ref, onMounted } from "vue";
import { useFinanceiroStore } from '@/stores/financeiro';

const financeiroStore = useFinanceiroStore();
const loadingSaldo = ref(false);

onMounted(async () => {
    loadingSaldo.value = true;
    try {
        await financeiroStore.fetchSaldo();
    } catch (error) {
        console.error('Erro ao carregar saldo:', error);
    } finally {
        loadingSaldo.value = false;
    }
});
</script>

<style scoped>
/* Skeleton para saldo */
.skeleton-saldo-value {
    width: 120px;
    height: 28px;
    background: linear-gradient(90deg, var(--skeleton-color-2, #d0d0d0) 25%, var(--skeleton-color-1, #e8e8e8) 50%, var(--skeleton-color-2, #d0d0d0) 75%) !important;
    background-size: 200% 100%;
    border-radius: 6px;
    animation: skeleton-shimmer 2s infinite ease-in-out;
}

.skeleton-saldo-amount {
    width: 80px;
    height: 20px;
    background: linear-gradient(90deg, var(--skeleton-color-2, #d0d0d0) 25%, var(--skeleton-color-1, #e8e8e8) 50%, var(--skeleton-color-2, #d0d0d0) 75%) !important;
    background-size: 200% 100%;
    border-radius: 4px;
    animation: skeleton-shimmer 2s infinite ease-in-out;
    margin: 10px auto 0;
}

.skeleton-line {
    height: 12px;
    background-color: var(--skeleton-color-2, #d0d0d0) !important;
    border-radius: 4px;
    margin-bottom: 8px;
    animation: skeleton-pulse 1.5s infinite ease-in-out;
}

.skeleton-line-value {
    width: 100%;
    height: 100%;
}

.skeleton-line-amount {
    width: 100%;
    height: 100%;
}

@keyframes skeleton-pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
}

@keyframes skeleton-shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

/* Variáveis CSS para modo claro/escuro */
:root {
    --skeleton-color-1: #e8e8e8;
    --skeleton-color-2: #d0d0d0;
    --skeleton-bg: #f0f0f0;
    --skeleton-bg-color: #ffffff;
}

[data-bs-theme="dark"] {
    --skeleton-color-1: #2d3748;
    --skeleton-color-2: #4a5568;
    --skeleton-bg: #1e293b;
    --skeleton-bg-color: #0f172a;
}

/* Forçar visibilidade dos skeletons no modo light */
body:not(.dark):not([data-bs-theme="dark"]) .skeleton-saldo-value,
body:not(.dark):not([data-bs-theme="dark"]) .skeleton-saldo-amount {
    background: linear-gradient(90deg, #c0c0c0 25%, #d5d5d5 50%, #c0c0c0 75%) !important;
    background-size: 200% 100%;
}

/* Correção para alinhamento à esquerda */
.wallet-balance .d-flex.flex-column.text-start {
    text-align: left !important;
    align-items: flex-start !important;
}

.wallet-balance .d-flex.flex-column.text-start p {
    text-align: left !important;
}
</style>
